<template>
  <div class="container" style="width: 100vw; height: 100vh;">
  <div class="card" style="padding: 30px;height: 80vh;overflow-y: scroll;margin-top: -30px;">
  <div class="card-body" style="margin-top: -40px;">
  <span class="text-danger fs-3 fw-bold">LTC Red Army</span><span class="text-black-50 fs-3 fw-bold"> Duties 2023</span>
  
  
  <br>
  <div v-if="tabActive==0" class="row justify-content-center" >
    <div class="col-12 text-center" style="background-color: #E3CDC9;">
      <b>!Please select the customer type(below tab)</b>
    </div>
  </div>
  <br>
  <div v-if="tabActive!=0" class="row">
    <div class="col-12 text-end">
      <button type="button" class="btn btn-primary" @click="clickAddBtn()">
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>
  <div class="row justify-content-center" >
      <ul class="nav nav-pills">
        <li class="nav-item" @click="tabActive=1">
          <a :class="'nav-link '+(tabActive==1?'active':'')"
          aria-current="page" href="javascript:void(0)" >Normal Customer</a>
        </li>
        <li class="nav-item" @click="tabActive=2">
          <a :class="'nav-link '+(tabActive==2?'active':'')"
          href="javascript:void(0)" >Dealer & Shop Customer</a>
        </li>
        <li class="nav-item" @click="tabActive=3">
          <a :class="'nav-link '+(tabActive==3?'active':'')"
          href="javascript:void(0)" >FTTH Customer</a>
        </li>
      </ul>
      <hr>
      <div v-if="tabActive==1">
      <!-- <div v-for="(questionData, index) in globalCustQ" v-bind:key="index"> -->
      <!-- <div class="row">
        <div class="col-xs-12 offset-sm-3 col-sm-9 text-start">
          {{ (index+1)+'.'+questionData.cust_question }}
        </div>
      </div> -->
      <!-- <div class="row">
        <div class="col-xs-12 offset-sm-3 col-sm-9" v-for="(question, index) in questionData.cust_q_choice" v-bind:key="index">
          <div class="form-check form-switch text-start">
            <input class="form-check-input" type="checkbox">
            <label class="form-check-label" for="flexSwitchCheckDefault">{{ question }}</label>
          </div>
        </div>
      </div>   -->
      <!-- </div> -->
      <table class="table table-striped" style="width:100%">
        <thead>
          <tr style="background-color:#AAB7B8">
            <th scope="col">#</th>
            <th scope="col">Question Type</th>
            <th scope="col">Question Name</th>
          </tr>
        </thead>
        <tbody >
          <tr :style="{'background-color':(questionData.cust_type=='Normal Customer'?'#ABEBC6':(questionData.cust_type=='FTTH Customer'?'#F5B7B1':'#F9E79F'))}" v-for="(questionData, index) in globalCustQ" v-bind:key="index" @click="clickRowQuestion(questionData);">
            <th scope="row">{{ index+1 }}</th>
            <td>{{ questionData.cust_type }}</td>
            <td>{{ questionData.cust_question }}</td>
          </tr>
        </tbody>
      </table>
     

      </div>
      <div v-if="tabActive==2">
        <div v-for="(questionData, index) in shopCustQ" v-bind:key="index">
        <div class="row">
          <div class="col-xs-12 offset-sm-3 col-sm-9 text-start">
            {{ (index+1)+'.'+questionData.cust_question }}
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-xs-12 offset-sm-3 col-sm-9" v-for="(question, index) in questionData.cust_q_choice" v-bind:key="index">
            <div class="form-check form-switch text-start">
              <input class="form-check-input" type="checkbox">
              <label class="form-check-label" for="flexSwitchCheckDefault">{{ question }}</label>
            </div>
          </div>
        </div>   -->
        </div>

        
      </div>
      <div v-if="tabActive==3">
        <div v-for="(questionData, index) in ftthCustQ" v-bind:key="index">
        <div class="row">
          <div class="col-xs-12 offset-sm-3 col-sm-9 text-start">
            {{ (index+1)+'.'+questionData.cust_question }}
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-xs-12 offset-sm-3 col-sm-9" v-for="(question, index) in questionData.cust_q_choice" v-bind:key="index">
            <div class="form-check form-switch text-start">
              <input class="form-check-input" type="checkbox">
              <label class="form-check-label" for="flexSwitchCheckDefault">{{ question }}</label>
            </div>
          </div>
        </div>   -->
        </div>
      </div>

  </div>

  </div>

  </div>

      <div class="row">
          <div class="col-12 text-center">
            <button type="submit" class="btn btn-danger" @click="$router.push('/home');" style="width:100%;" >
            <i class="fas fa-house"></i> Home
          </button>
          </div>
          <!-- <div class="col-6 text-center">

          <button v-if="tabActive!=0" type="submit" class="btn btn-success" style="width:100%;" @click="clickSave();">
            <i class="fas fa-floppy-disk"></i> Send
          </button>
          </div> -->
      </div>
  </div>


<div class="modal fade" id="editQuestionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-xl" >
    <div class="modal-content" >
      <div class="modal-header">

        <h5 class="modal-title" id="exampleModalLabel">{{flagEditQDetail?'Edit question':(flagEditQDetail==null?'Adding Question and Choice':'Question Details')}}</h5>&nbsp;<i class="fas fa-pen-to-square fa-2xl" @click="flagEditQDetail=true"></i>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" :style='!flagEditQDetail&&flagEditQDetail!=null?{"pointer-events": "none","opacity": "0.4"}: {}'>
          <div class="row" style="padding-bottom: 10px;">
            <div class="col-2"></div>
            <div class="col-3 text-start">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" checked>
                <label class="form-check-label" for="inlineRadio1">English</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2">
                <label class="form-check-label" for="inlineRadio2">Lao</label>
              </div>
            </div>
          </div>
          <div class="row" v-if="flagEditQDetail!=null">
            <div class="col-1"></div>
            <div class="col-10">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">Question No.</span>
                <input type="text" value="1" class="form-control" aria-describedby="basic-addon1" disabled>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">Question Type</span>
                <input type="text" class="form-control" aria-describedby="basic-addon1" value="Normal Customer">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">Question Message</span>
                <textarea class="form-control" style="height: 100px">Question number 1?</textarea>
              </div>
            </div>
          </div>
          <hr>

          <table class="table table-success table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Choice Message</th>
                <th scope="col">Is multiple choice</th>
              </tr>
            </thead>
            <tbody >
              <tr>
                <th scope="row">1</th>
                <td><input type="text" class="form-control" value="choice number one" ></td>
                <td class="text-center">
                    <input class="form-check-input" type="checkbox" id="flexCheckDefault" checked>
                </td>
              </tr>
              <tr>
                <th scope="row">2</th>
                <td><input type="text" class="form-control" value="choice number two" ></td>
                <td class="text-center">
                    <input class="form-check-input" type="checkbox" id="flexCheckDefault" checked>
                </td>
              </tr>
              <tr>
                <th scope="row">3</th>
                <td><input type="text" class="form-control" value="choice number three" ></td>
                <td class="text-center">
                    <input class="form-check-input" type="checkbox" id="flexCheckDefault" checked>
                </td>
              </tr>
              <tr>
                <th scope="row">4</th>
                <td><input type="text" class="form-control" value="choice number four"></td>
                <td class="text-center">
                    <input class="form-check-input" type="checkbox" id="flexCheckDefault">
                </td>
              </tr>
            </tbody>
          </table>
          
      </div>
      <div class="modal-footer">
        <button @click="clickDelete();" v-if="flagEditQDetail&&flagEditQDetail!=null" type="button" class="btn btn-danger" data-bs-dismiss="modal">Delete</button>
        <button v-if="flagEditQDetail||flagEditQDetail==null" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button @click="clickSave()" v-if="flagEditQDetail||flagEditQDetail==null" type="button" class="btn btn-primary">Save</button>
      </div>
    </div>
  </div>
</div>
  
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { Modal } from 'bootstrap'

export default {
name: 'AddingQuestionAndChoice',
props: {
  msg: String
},
data() {
  return {
    keypad: [
      [1, 2, 3],
      [4, 5, 6],
      [7, 8, 9],
      [null, 0, null],
    ],
    tabActive:0,
    globalCustQ:[
    {
      cust_question:"Question number 1?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question number 2?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question number 3?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question number 4?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question number 5?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
  ],
    shopCustQ:[
    {
      cust_question:"Question number 1 ?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question number 2?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question number 3?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question number 4?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question number 5?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
  ],
    ftthCustQ:[
    {
      cust_question:"Question FTTH number 1?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question FTTH number 2?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question FTTH number 3?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question FTTH number 4?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
    {
      cust_question:"Question FTTH number 5?",
      cust_q_choice:["choice number one.","choice number two.","choice number three.","choice non."],
      non_choice:4
    },
  ],
  lat:0.00,
  lng:0.00
  };
},
mounted() {
  this.getLocation();
  this.editQuestionModal = new Modal(document.getElementById('editQuestionModal'));
},
methods: {
 verifyOtp: function(){
  this.$router.push("/home");
 },
getLocation: function() {
if (navigator.geolocation) {
  navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
} else {
  alert("Geolocation is not supported by this browser.");
}
},
showPosition: function(position) {
  this.lat = position.coords.latitude;
  this.lng = position.coords.longitude;
  // var latitude = position.coords.latitude;
  // var longitude = position.coords.longitude;
  // do something with the user's location data
},
showError:function(error) {
  switch(error.code) {
    case error.PERMISSION_DENIED:
      alert("User denied the request for Geolocation.");
      break;
    case error.POSITION_UNAVAILABLE:
      alert("Location information is unavailable.");
      break;
    case error.TIMEOUT:
      alert("The request to get user location timed out.");
      break;
    case error.UNKNOWN_ERROR:
      alert("An unknown error occurred.");
      break;
  }
},
clickSave:function(){
  var vm = this;

    vm.$swal.fire({
      title: 'Do you want to send data?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Send',
      denyButtonText: `Cancel`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        vm.$swal.fire('Completed!', '', 'success')
        vm.tabActive = 0;
      } else if (result.isDenied) {
        // this.$swal.fire('Changes are not saved', '', 'info')
      }
    });
        
  
    
  },
validateForm:function(){
  var flag = true;
  if(this.tabActive==0){
      flag = false;
  }
  return flag
},
clickAddBtn:function(){
    var vm = this;
    vm.editQuestionModal.show();
    vm.flagEditQDetail = null;
  },
  clickDelete:function(){
    var vm = this;

      vm.$swal.fire({
        title: 'Do you want to delete this Question?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirm',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.$swal.fire('Completed!', '', 'success')
          vm.editQuestionModal.hide();
        } else if (result.isDenied) {
          // this.$swal.fire('Changes are not saved', '', 'info')
        }
      });
    }
}
};
</script>

<style scoped>
.otp-keypad {
max-width: 50%;
margin: 0 auto;
}

.otp-keypad-button {
font-size: 1.5rem;
font-weight: bold;
border-radius: 50%;
height: 60px;
width: 60px;
line-height: 60px;
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
background-color: #f1f1f1;
border: none;
outline: none;
color: #333;
}

.otp-keypad-empty-space {
height: 60px;
width: 60px;
background-color: transparent;
}

.nav-link.active {
background-color: gray;
}
</style>
